// 存储localStorage
export const set = (key, value) => {
    localStorage.setItem(key, JSON.stringify(value));
  };
  
  // 得到localStorage
  export const get = (key) => {
    return JSON.parse(localStorage.getItem(key))
  };
  
  // 删除localStorage
  export const del = (key) => {
    localStorage.removeItem(key);
  };
  
  // 清空localStorage
  export const clear = () => {
    localStorage.clear();
  };